export default {"src":"/_next/static/media/taas.25d536d1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};